import {BreadcrumbType} from 'platform/components';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {GatewayKonzulta} from './components/GatewayKonzulta';

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('page.integrations.labels.smsGateways'),
    href: settingsRoutes.smsGateways,
  },
];

export function SmsGatewaysKonzulta() {
  return (
    <SettingsTemplate
      header={{title: i18n.t('page.integrations.labels.smsGatewayKonzulta'), breadcrumbs}}
      data-testid="integrations-smsGateways-settings"
    >
      <GatewayKonzulta />
    </SettingsTemplate>
  );
}
